import type { ApiResponse } from 'types';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1';

export const CONSUMER_TOKEN_KEY = 'tp_consumer_token';
export const CONSUMER_USER_KEY = 'tp_consumer_user';

const getToken = () => localStorage.getItem(CONSUMER_TOKEN_KEY);

const buildHeaders = (hasBody: boolean): Record<string, string> => {
  const headers: Record<string, string> = {};
  if (hasBody) headers['Content-Type'] = 'application/json';
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
};

const handleUnauthorized = () => {
  localStorage.removeItem(CONSUMER_TOKEN_KEY);
  localStorage.removeItem(CONSUMER_USER_KEY);
  if (!window.location.pathname.startsWith('/consumer/login')) {
    window.location.href = '/consumer/login';
  }
};

const request = async <T = unknown>(
  method: string,
  endpoint: string,
  body?: unknown
): Promise<ApiResponse<T>> => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method,
      headers: buildHeaders(body !== undefined),
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });

    if (response.status === 401) {
      handleUnauthorized();
    }

    return (await response.json()) as ApiResponse<T>;
  } catch (error) {
    console.error(`Consumer API ${method} ${endpoint} Error:`, error);
    throw error;
  }
};

export const consumerApi = {
  get: <T = unknown>(endpoint: string) => request<T>('GET', endpoint),
  post: <T = unknown>(endpoint: string, body: unknown) => request<T>('POST', endpoint, body),
};
